
import React from 'react'
import img from "../../assets/Group 1000015002.png"
import { Link } from 'react-router-dom'
const Hero = () => {
  return (
    <section className='pt-[0px] md:pt-[75px]'>
      <section className=" w-[90%] mx-auto flex md:flex-col">

        <div className='w-[50%] md:w-full my-auto'>
          <h2 className='text-6xl md:text-[30px] font-medium text-white pt-36 md:pt-5'>
            <span className='text-[#312A46]'>Your Success is</span>  <span className='text-[#6459C3]'>99.9%</span>
          </h2>
          <h2 className='text-6xl md:text-[30px] font-medium text-[#312a46]'>
            <span className='text-[#EA7851]'>Guaranteed</span> with us
          </h2>
          <p className='text-[#3D3939] text-lg md:text-base md:w-[100%] font-normal w-[90%] my-5'>
            We are your partners in unlocking the doors to your educational success. With passion and professionalism, we offer innovative education solutions globally. Join us and start your path to success today!
          </p>
          <Link to="/contact">
          <button className='mb-20 md:mb-0 mt-6 bg-[#5146AE] rounded-lg text-white w-[159px] h-[56px] font-medium text-base'>Contact Us</button>
          </Link>
        </div>
        <div className='w-[50%] md:w-full'>
          <img src={img} alt="Quest" style={{pointerEvents: 'none'}} />
        </div>

      </section>
    </section>
  )
}

export default Hero